import { render, staticRenderFns } from "./OInfoBlock.vue?vue&type=template&id=250fd5fc&"
import script from "./OInfoBlock.vue?vue&type=script&lang=js&"
export * from "./OInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./OInfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports